import "./App.css";
import TestForm from "./TestForm";

const AddContact = () => {
  return (
    <section>
      <TestForm />
    </section>
  );
};

export default AddContact;